import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const WorkFilterItem = styled(StyledFlexContainer)`
	justify-content: center;
	align-items: center;
	padding: 0.5rem 1rem;
	border-radius: 5rem;
	font-weight: 700;
	font-size: 0.9rem;
	cursor: pointer;
	transition: all 0.2s ease;
	border: 1px solid lightgray;
	background-color: ${({ activeFilter, item, theme }) =>
		activeFilter === item
			? theme.color.selectedBackgroundColor
			: theme.color.unSelectedBackgroundColor};

	color: ${({ activeFilter, item, theme }) =>
		activeFilter === item ? theme.color.selectedTextColor : theme.color.unSelectedTextColor};

	&:hover {
		background-color: var(--secondary-color);
		color: ${({ theme }) => theme.color.workFilterItemHoverBackground};
	}
	@media screen and (min-width: 2000px) {
		padding: 1rem 2rem;
		border-radius: 0.85rem;
	}
`;

export default WorkFilterItem;
